import React, { useContext, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import BreakpointContext from "../../contexts/breakpointContext";
import NavLinksContext from "../../contexts/navLinksContext";
import { getCurrentUser } from "../../store/slices/auth";
import NavBot from "./NavBot";
import NavSide from "./NavSide";
import NavTop from "./NavTop";
import links from "./links";

const StyledNav = styled.nav`
  font-size: 0.75rem;
  position: relative;
  white-space: nowrap;
  width: 100%;
  z-index: 2;
`;

const NavMain = () => {
  const location = useLocation();
  const currentUser = useSelector(getCurrentUser);
  const breakpoints = useContext(BreakpointContext);

  const [navSideOn, setNavSideOn] = useState(false);

  const toggleNavSideOn = () => {
    setNavSideOn(!navSideOn);
  };

  const isAdmin = /^\/admin/.test(location.pathname);
  const showNavBot = !!currentUser.isLoggedIn && !!breakpoints.md && !isAdmin;
  const showNavSide = currentUser.isLoggedIn && !breakpoints.md;

  return (
    <NavLinksContext.Provider value={links}>
      <StyledNav>
        <NavTop toggleNavSideOn={toggleNavSideOn} />
        {showNavBot && <NavBot />}
        {showNavSide && (
          <NavSide isOn={navSideOn} toggleNavSideOn={toggleNavSideOn} />
        )}
      </StyledNav>
    </NavLinksContext.Provider>
  );
};

export default NavMain;
